import React, { useEffect, useState } from 'react'
import { NavBar } from '../../../components/NavBar/NavBar'
import {
  Flex,
  H1WithBack,
  PageWrapper,
  ContentWrapper,
} from '../../../styling/GlobalStyles'
import { ModelsSpecificationTab } from './ModelsSpecificationTab'
import { useDispatch, useSelector } from 'react-redux'
import { toast } from 'react-toastify'
import { useNavigate, useParams } from 'react-router-dom'
import { AppDispatch, RootState } from 'store'
import {
  getSingleMachineModel,
  clearModel,
  updateMachineModel,
} from 'features/machineModels/machineModelsSlice'
import { IMachineModel } from 'types/machineModels.interface'


export const EditModel = () => {
  const dispatch = useDispatch<AppDispatch>()
  const navigate = useNavigate()
  const { singleModel } = useSelector((state: RootState) => state.machineModels)
  const [state, setState] = useState<IMachineModel>({
    category: null,
    fields: [],
    fuelType: null,
    id: null,
    make: '',
    model: '',
  })
  const { id } = useParams()
  const [invalidFields, setInvalidFields] = useState<string[]>([])

  const handleSubmit = async () => {



    if (invalidFields.length < 1) {
      const resp = await dispatch(updateMachineModel(state))
      if (resp.meta.requestStatus === 'fulfilled') {
        navigate('/resources-models')
      }
    } else {
      toast.warn('All fields must be valid')
    }
  }

  useEffect(() => {
    dispatch(getSingleMachineModel(id))
    return () => {
      dispatch(clearModel())
    }
  }, [])


  useEffect(() => {
    if (singleModel) {
      setState(structuredClone(singleModel))
    }
  }, [singleModel])

  return (
    <div>
      <NavBar />
      <PageWrapper noFooter>
        <Flex between main>
          <H1WithBack
            mb='1.5'
            arrow
            title={'Edit ' + (singleModel?.model ? singleModel?.model : '')}
          />
        </Flex>
        <ContentWrapper>
          <ModelsSpecificationTab
            state={state}
            setState={setState}
            handleSubmit={handleSubmit}
            invalidFields={invalidFields}
            setInvalidFields={setInvalidFields}
          />
        </ContentWrapper>
      </PageWrapper>
    </div>
  )
}
